import BaseService from "../../base/base_service";
import IGeoRetryService from "./geo_retry_service_interface";
import {geoRetryResponse} from "../oauth/user/user_service_interface";
import {IGeoRequestParams} from "./geo_service_interface";
import {GEO_LOCATION} from "./geo_consts";
import {Check} from "@sparkware/app-utils";
import _ from '../../utils/underscore';
import {CHANNEL_SOURCE} from "../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";

export default class GeoRetryService extends BaseService implements IGeoRetryService{
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'GeoRetryService';

    /**
     * Check if the user is eligible for retry geo location.
     * @param troubleshooterRetry
     * @param retryForOpenGameFlow
     */
    public isEligible(troubleshooterRetry: boolean):boolean {
        return this._isRetryEnabled() && troubleshooterRetry;
    }

    public isEligibleForAutoRetry(troubleshooterRetry: boolean, kickReasonID: string, troubleshooterMessages: string | string[] | null): boolean {
        const hasTroubleShooterMessage = !Check.isNullOrUndefined(troubleshooterMessages) && (!Check.isArray(troubleshooterMessages) || troubleshooterMessages.length > 0);

        return this.isEligible(troubleshooterRetry) && kickReasonID === "25" && !hasTroubleShooterMessage;
    }

    public getRetryMessageButtons(analyticsLabel: string, resolve, reject): any[] {
        return [
            {
                name: this.serviceFactory.languageService().translation('retry').toUpperCase(),
                callback: () => {
                    this._sendAnalytics('retry button clicked', analyticsLabel);
                    this.serviceFactory.geoLocationService().startRetryGeoProcess().then(()=> {
                        resolve && resolve();
                    }).catch(()=>{
                        reject && reject();
                    });
                }
            },
            {
                name: this.serviceFactory.languageService().translation('contact_us').toUpperCase(),
                type: "secondary",
                callback: () => {
                    this._sendAnalytics('contact us button clicked', analyticsLabel);
                    this.serviceFactory.casinofiedAppLauncherProxyService().openContactUs({
                        businessCorrelationID: _.getGuid(),
                        channel: {
                            source: CHANNEL_SOURCE.geoLocationRetry,
                            area: AreaType.button
                        }
                    });
                    reject && reject();
                }
            }
        ]
    }

    public async initGeoRetry(isAutoRetry: boolean = false): Promise<IGeoRequestParams | null> {
        this._sendAnalytics('call init geo retry api');
        try {
            const initRetryResponse: geoRetryResponse = await this.serviceFactory.userService().initGeoRetry();
            this._sendAnalytics(`Error code: ${initRetryResponse?.ErrorCode}`);

            const accountData = this.serviceFactory.userService().getAccountData();

            return {
                mobileNumber: accountData.MobileNumber,
                licenseKey: initRetryResponse.GeoComplyLicense,
                locationTransactionId:initRetryResponse.LocationTransactionToken,
                isGeoLocationInProcess:true,
                isRetryFlow: true,
                isAutoRetryFlow: isAutoRetry
            };
        } catch(err) {
            this._sendAnalytics(`init geo api fail with status code: ${err?.error_code}`);
            return null;
        }

    }

    private _isRetryEnabled() {
        return this.serviceFactory.userService().isGeoRetryEnable();
    }

    private _sendAnalytics(action:string, label: string = null):void {
        const analyticsData:any = {
            CGPEventCategory: GEO_LOCATION.GA_GEO_LOCATION_CATEGORY_SERVICE,
            CGPEventAction: action,
            CGPEventLabel: label
        };

        this.serviceFactory.structuredLoggingService().getLogger(analyticsData).info();
    }
}